import { useState } from "react";
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { MoreVert, GroupAdd, PersonAdd, PersonRemove, CheckBox as CheckBoxIcon } from "@mui/icons-material";
import { PortalTooltip } from "../../../../../../helpers";

export function EntityCardMenu({
	entityId,
	onAssignAll,
	onAssignUnassigned,
	onUnassignAll,
	selectedCount,
	onAssignSelected,
}: {
	entityId: string;
	onAssignAll: (entityId: string) => void;
	onAssignUnassigned: (entityId: string) => void;
	onUnassignAll: (entityId: string) => void;
	selectedCount: number;
	onAssignSelected: (entityId: string) => void;
}) {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	return (
		<>
			<PortalTooltip title="Bulk Assignment Options">
				<IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
					<MoreVert fontSize="small" />
				</IconButton>
			</PortalTooltip>
			<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
				<MenuItem
					disabled={selectedCount === 0}
					onClick={() => {
						onAssignSelected(entityId);
						setAnchorEl(null);
					}}
				>
					<ListItemIcon>
						<CheckBoxIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText>Assign selected growers ({selectedCount})</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() => {
						onAssignAll(entityId);
						setAnchorEl(null);
					}}
				>
					<ListItemIcon>
						<GroupAdd fontSize="small" />
					</ListItemIcon>
					<ListItemText>Assign all growers</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() => {
						onAssignUnassigned(entityId);
						setAnchorEl(null);
					}}
				>
					<ListItemIcon>
						<PersonAdd fontSize="small" />
					</ListItemIcon>
					<ListItemText>Assign unassigned growers</ListItemText>
				</MenuItem>
				<MenuItem
					onClick={() => {
						onUnassignAll(entityId);
						setAnchorEl(null);
					}}
				>
					<ListItemIcon>
						<PersonRemove fontSize="small" />
					</ListItemIcon>
					<ListItemText>Unassign all growers</ListItemText>
				</MenuItem>
			</Menu>
		</>
	);
}
